export default __webpack_public_path__ + "static/media/time.e79b37e0.svg";